import { useQuery } from '@tanstack/react-query';
import accountsService from '@/lib/api/accounts';
import type { AccountsFilters } from '@/lib/api/accounts';

export function useAccountsList(
  organizationId: string | undefined,
  options?: AccountsFilters & { enabled?: boolean },
) {
  const query = useQuery({
    queryKey: [
      'accounts',
      organizationId,
      options?.limit,
      options?.offset,
      options?.search,
      options?.health,
      options?.min_users,
      options?.date_from,
      options?.date_to,
      options?.sort_by,
      options?.sort_direction,
    ],
    queryFn: async () => {
      if (!organizationId) throw new Error('Organization ID required');

      const response = await accountsService.getAccountsList(organizationId, {
        limit: options?.limit,
        offset: options?.offset,
        search: options?.search,
        health: options?.health,
        min_users: options?.min_users,
        date_from: options?.date_from,
        date_to: options?.date_to,
        sort_by: options?.sort_by,
        sort_direction: options?.sort_direction,
      });

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to fetch accounts');
      }
      return response.data;
    },
    enabled: !!organizationId && (options?.enabled ?? true),
    staleTime: 30 * 1000,
  });

  return {
    accounts: query.data?.accounts || [],
    total: query.data?.total || 0,
    isLoading: query.isLoading,
    error: query.error,
  };
}
